import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index.tsx';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionFeaturesWithIcon',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'FeatureWithIcon',
        options: {
          features: [
            {
              title: 'Improve operational efficiency',
              text: 'Fuel retail and eCommerce AI with accurate and enhanced product data. Boost traffic and conversion with a high-quality catalog. Cleanse defectsand enhance attributes across a full product schema.',
              icon: 'ATM'
            },
            {
              title: 'Improve operational efficiency',
              text: 'Fuel retail and eCommerce AI with accurate and enhanced product data. Boost traffic and conversion with a high-quality catalog. Cleanse defectsand enhance attributes across a full product schema.',
              icon: 'Accessibility'
            },
            {
              title: 'Improve operational efficiency',
              text: 'Fuel retail and eCommerce AI with accurate and enhanced product data. Boost traffic and conversion with a high-quality catalog. Cleanse defectsand enhance attributes across a full product schema.',
              icon: 'Activity'
            }
          ]
        }
      }
    }
  ]
});
